var _defs, _rect, _text, _path, _path2, _g, _path3, _path4, _g2, _g3, _rect2, _rect3, _g4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle, _circle2, _path10, _path11, _path12, _path13, _line, _line2, _path14, _rect4, _path15, _rect5, _polygon, _polygon2, _rect6, _rect7, _path16, _path17, _polygon3, _polygon4, _polygon5, _path18, _path19, _line3, _g5, _path20, _path21, _path22, _path23, _path24, _circle3, _circle4, _g6, _path25, _path26, _path27, _path28, _path29, _g7, _g8, _path30, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackagingdesignproduction6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-14,.cls-16,.cls-17,.cls-21,.cls-22,.cls-27,.cls-28,.cls-32,.cls-35{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-3,.cls-4{fill:#2f2143;}.cls-5{opacity:0.8;}.cls-6{clip-path:url(#clip-path);}.cls-7{fill:#fdc435;}.cls-8{clip-path:url(#clip-path-2);}.cls-9{clip-path:url(#clip-path-3);}.cls-10{clip-path:url(#clip-path-4);}.cls-11{fill:#e5aa80;}.cls-12{fill:#9a499c;}.cls-13{fill:#263238;}.cls-14{stroke:#263238;stroke-linecap:round;stroke-width:1.7px;}.cls-14,.cls-16,.cls-17,.cls-21,.cls-22,.cls-27,.cls-28,.cls-32,.cls-35{stroke-miterlimit:10;}.cls-15{fill:#e8996f;}.cls-16{stroke:#303030;}.cls-16,.cls-17{stroke-width:0.85px;}.cls-17{stroke:#e8996f;}.cls-18{fill:#713875;}.cls-19{fill:#a7bdc6;}.cls-20{fill:#e6e6e6;}.cls-21{stroke:#c5d3d8;}.cls-21,.cls-22{stroke-width:1px;}.cls-22{stroke:#a7bdc6;}.cls-23{opacity:0.5;}.cls-24{clip-path:url(#clip-path-5);}.cls-25{fill:#fff;}.cls-26{fill:#293b4a;}.cls-27{stroke:#2f2143;}.cls-27,.cls-28{stroke-width:2px;}.cls-28{stroke:#9a499c;}.cls-29{clip-path:url(#clip-path-6);}.cls-30{fill:#f2d686;}.cls-31{fill:#2e1f42;}.cls-32{stroke:#4f4e4f;stroke-width:0.88px;}.cls-33{clip-path:url(#clip-path-7);}.cls-34{clip-path:url(#clip-path-8);}.cls-35{stroke:#2e1f42;stroke-width:1.25px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1462.23,
    y: 198.64,
    width: 61.37,
    height: 52.98,
    transform: "translate(-9.22 377.06) rotate(-14.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1407.6,
    y: 98.68,
    width: 35.32,
    height: 114.8,
    transform: "translate(5.79 358.13) rotate(-14.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1501.22,
    y: 74.5,
    width: 35.5,
    height: 114.83,
    transform: "translate(14.7 380.61) rotate(-14.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1337.6,
    y: 119.74,
    width: 10.68,
    height: 114.83,
    transform: "translate(-2 338.39) rotate(-14.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1218.22,
    y: 232.82,
    width: 66.62,
    height: 66.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 459.35,
    y: 224.99,
    width: 36.83,
    height: 41.72,
    transform: "translate(-58.92 219.98) rotate(-24.47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460.2,
    y: 232.79,
    width: 8.97,
    height: 8.43,
    transform: "translate(-56.43 213.76) rotate(-24.47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458.6,
    y: 231.54,
    width: 12.58,
    height: 11.82,
    transform: "translate(-56.6 213.89) rotate(-24.47)"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PACKAGING DESIGN &amp;amp; PRODUCTION 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1600,
    height: 326
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(471.65 165.7)"
  }, "PACKAGING DESIGN", /*#__PURE__*/React.createElement("tspan", {
    x: 93.75,
    y: 75
  }, "&amp; PRODUCTION"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1517.09,53.85c-3.2.82-6.62-1.46-8.06-7.07l-1.2-4.38-15.42,3.94a2.84,2.84,0,0,0-2.18,3.43,2.8,2.8,0,0,0,3.55,2l4.26-1.09a.28.28,0,0,1,.36.21.29.29,0,0,1-.21.37l-17.07,4.37,6.43,25.11,34.21-8.76Zm-1.31,17.32-2.22.57L1510.82,61l-11-3.16s-.46-.07-.51-.4.32-.39.32-.39l11.8-3Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1398.78,70.5a2.78,2.78,0,1,0,1.38,5.38l4.26-1.09a.3.3,0,0,1,.14.58l-8.49,2.18c.82,3.2-1.46,6.61-7.07,8l4.92,19.25,34.22-8.76-8-31.07Zm10.67,10.68-8.15,8.07L1404,100l-2.23.57-4.37-17.1,11.79-3s.36-.12.48.19-.26.59-.26.59",
    transform: "translate(0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1456.62,207.07l8.76,34.24,10.76,15.45,46.1-11.79,2.6-18.87-8.76-34.24Zm43.69,26.9a5,5,0,1,1-9.63,2.46l-.68-2.67a5,5,0,1,1,9.62-2.46Z",
    transform: "translate(0)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1422.38,216.1l4.93,19.24c5.61-1.43,9.25.47,10.07,3.67l8.49-2.17a.28.28,0,0,1,.36.22.28.28,0,0,1-.21.36l-4.26,1.09a2.82,2.82,0,0,0-2.18,3.43,2.84,2.84,0,0,0,3.56,1.95l21.41-5.47-8-31.08Zm25.17,14.09-11.79,3-4.38-17.11,2.22-.57,2.74,10.71,11,3.15s.45.08.51.4-.33.4-.33.4",
    transform: "translate(0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1516.19,191.9l6.42,25.11,17.07-4.37a.29.29,0,0,1,.36.22.29.29,0,0,1-.22.36l-4.25,1.09a2.8,2.8,0,0,0-2.18,3.43,2.84,2.84,0,0,0,3.55,2l15.43-3.95-1-4.42c-1.43-5.61.47-9.25,3.67-10.07l-4.59-18.11Zm33.54,11.95-11.8,3s-.36.11-.47-.19.26-.6.26-.6l8.15-8.06-2.74-10.71,2.22-.57Z",
    transform: "translate(0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1407.6,
    y: 98.68,
    width: 35.32,
    height: 114.8,
    transform: "translate(5.79 358.13) rotate(-14.35)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1501.22,
    y: 74.51,
    width: 35.5,
    height: 114.83,
    transform: "translate(14.7 380.61) rotate(-14.35)"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1441.36,
    y: 86.52,
    width: 61.37,
    height: 114.83,
    transform: "translate(10.26 369.35) rotate(-14.35)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1347.15,
    y: 110.75,
    width: 61.88,
    height: 114.83,
    transform: "translate(1.32 346.82) rotate(-14.35)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1350.86 229.65 1362.35 231.46 1333.88 120.21 1324.94 128.34 1350.86 229.65"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M261.33,224.67,264.55,235l37-32.75L317.09,183l9.18-3.77-4.43,7.69a55.52,55.52,0,0,0,7.82-1.82c10.83-3.37,16.54-8.79,18.39-7.18,1.22,1.07-.07,4.44-.78,6.13-2.17,5.19-7.52,15.27-21.91,28.05l-9,2.34s-26.72,42.31-35.29,49.1c0,0-10.48,14.1-20.82,14.66,0,0-28.42,3.91-34.33-23.6,0,0-3.26-19.5-1.71-19.92Z",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M236.26,326s-13.4-85.86-12.17-90.19l40.32-10.87s-13.7-62.42-39.91-72.69c0,0-44.24-6.72-52.18-6.71l2.61,6.26L163.48,176,128,166.81l-4.82-14L84.75,175.18s-6.22,1.18-8.59,14.11L63.8,236.72l34.28-1.11s14.92,36.27,13.69,47.06l-3,43.33Z",
    transform: "translate(0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M128.62,168.78,164,177.15l11.6-23.4L172,143.5s14.58-6.32,12.68-24c0,0-18.11-50.83-24-55.32S103.46,45,102.79,77.47l5.72,35.6s-9.53,2-7.36,10.31S108.42,135.32,116,132Z",
    transform: "translate(0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M65.75,236.68,96,235.75l-.42,5s60-57.26,61-59.83h20.89l13.38,17.66s-4.05.53-6.55-.54c0,0-1.51,0-5-5.88,0,0,2.62,5.9,1.76,8.32a57.24,57.24,0,0,1-2.71,6.69s-1.68,4.1-2.78,4.49-.88.8-4.32,0c0,0-4.5-1.29-5.22-3.59a1.77,1.77,0,0,1,1.27-2.18l-5.49-.87s-6,10.18-8.11,12.25c0,0-2.23,3.37-9.9,6l-31.34,54.61a66,66,0,0,1-17.29,19.42L75.51,309.49s-10.25-2.09-16.73-7.34c0,0-5.25-4.6-3.84-22.12C54.94,280,61.61,244,65.75,236.68Z",
    transform: "translate(0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M110.19,119s8-9.83.66-15.18c0,0,7.82-3.42-5.56-22.54,0,0,18.72-9.84,17.88-16.06,0,0,23.31,9.87,35.2.92,0,0,11.81-6.25,7.32-13.17,0,0,5-21.62-16.18-15.39,0,0-16.81-8.37-29.63,4.84,0,0-19.53-1.15-24.59,15,0,0-18.66,13.39-7.71,23.63,0,0-7.78,8.16,4.61,13.36C92.19,94.45,105.4,119.16,110.19,119Z",
    transform: "translate(0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M124,92.49s1.06-8.64,13-5.31",
    transform: "translate(0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M151.08,83.1s1.06-8.64,13-5.32",
    transform: "translate(0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 137.02,
    cy: 97.1,
    r: 2.71
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 162.11,
    cy: 89.12,
    r: 2.71
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M146.09,89.46c1.42,1.21,2.82,2.44,4.19,3.71S153,95.69,154.37,97s2.71,2.56,4,3.88l4,4,.44.43-.59.15c-2.69.66-5.38,1.32-8.1,1.88,2.62-.92,5.27-1.74,7.92-2.55l-.15.58-4.05-3.86c-1.36-1.27-2.65-2.62-4-3.92s-2.63-2.65-3.93-4S147.34,90.84,146.09,89.46Z",
    transform: "translate(0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M142.83,119a20.23,20.23,0,0,0,3,3,9.81,9.81,0,0,0,3.55,1.81,5.29,5.29,0,0,0,1,.2l.49.09c.17,0,.33,0,.5,0,.33,0,.67,0,1,0s.68-.07,1-.09a5.15,5.15,0,0,0,1-.17l1-.19c.7-.18,1.39-.4,2.14-.54a19,19,0,0,1-1.83,1.32,12.75,12.75,0,0,1-2.12.87,8.52,8.52,0,0,1-4.7.1,8.32,8.32,0,0,1-4-2.48A8.85,8.85,0,0,1,142.83,119Z",
    transform: "translate(0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M172,143.5s-13.16,5.19-20.91,0c0,0,6.86,11.86,22.59,6.1Z",
    transform: "translate(0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M224.5,152.23s-5.64,8.84-5.64,27.36",
    transform: "translate(0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 225.39,
    y1: 235.23,
    x2: 224.5,
    y2: 197.45
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 98.08,
    y1: 235.61,
    x2: 91.07,
    y2: 197.45
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M265.44,233.94s-14.28,2.48-11.62,15.1",
    transform: "translate(0)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 319.78,
    y: 92.03,
    width: 45.02,
    height: 87.95
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M168.82,181l-20.11-41.77s.11-5.32,5.1-2.51L176.05,181Z",
    transform: "translate(0)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 304.54,
    y: 111.05,
    width: 45.02,
    height: 87.95
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "349.56 111.05 364.8 92.03 364.8 179.99 349.56 199 349.56 111.05"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "349.56 111.05 364.8 92.03 319.78 92.03 304.54 111.05 349.56 111.05"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 315.02,
    y: 146.47,
    width: 1.32,
    height: 2.21,
    transform: "translate(127.38 440.79) rotate(-82.35)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 341.89,
    y: 149.38,
    width: 1.32,
    height: 2.21,
    transform: "translate(180.63 487.78) rotate(-88.07)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M343.1,135.15a.87.87,0,0,1-1.22,0,.86.86,0,0,1,1.19-1.25.87.87,0,0,1,0,1.22",
    transform: "translate(0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M312.36,138a.82.82,0,1,1,0-1.16.82.82,0,0,1,0,1.16",
    transform: "translate(0)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "339.49 164.9 334.34 174.13 321.88 173.28 317.68 163.05 328.75 137.29 331.93 145.61 339.49 164.9"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "334.09 178.61 320.84 177.84 321.21 172.94 334.46 173.72 334.09 178.61"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "328.39 144.43 329.34 144.55 328.57 164.86 327.63 164.74 328.39 144.43"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M330.4,164.19a2.19,2.19,0,1,1-2-2.35h0a2.18,2.18,0,0,1,2,2.35",
    transform: "translate(0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M315.68,147.19c1.57-6.53,7.56-11.39,13.81-11.16,7.06.25,13.07,6.43,13.06,14.08",
    transform: "translate(0)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 311.83,
    y1: 137.41,
    x2: 342.39,
    y2: 134.63
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1281.37,299.34h-59.68a3.47,3.47,0,0,1-3.47-3.47V236.3a3.47,3.47,0,0,1,3.47-3.48h59.68a3.47,3.47,0,0,1,3.47,3.48v59.57a3.47,3.47,0,0,1-3.47,3.47",
    transform: "translate(0)"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1284.84,241.09h-66.62v-5a3.25,3.25,0,0,1,3.25-3.26h60.18a3.2,3.2,0,0,1,3.19,3.2Z",
    transform: "translate(0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1278,237.07a1.75,1.75,0,1,1-1.75-1.75,1.75,1.75,0,0,1,1.75,1.75",
    transform: "translate(0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1273,237a1.75,1.75,0,1,1-1.75-1.75A1.75,1.75,0,0,1,1273,237",
    transform: "translate(0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1268,237a1.75,1.75,0,1,1-1.75-1.75A1.75,1.75,0,0,1,1268,237",
    transform: "translate(0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1268.67,251.28V261h-1a15.37,15.37,0,0,0-1.89-4.84,7.32,7.32,0,0,0-2.83-2.35,9.08,9.08,0,0,0-3.53-.48h-2.68v27.74a11.06,11.06,0,0,0,.31,3.45,2.68,2.68,0,0,0,1.19,1.2,4.77,4.77,0,0,0,2.43.52h1.19v1h-18.83v-1h1.2a5,5,0,0,0,2.52-.56,2.47,2.47,0,0,0,1.08-1.27,10.75,10.75,0,0,0,.29-3.34V253.34h-2.59c-2.43,0-4.18.52-5.28,1.54a10.19,10.19,0,0,0-2.92,6.13h-1v-9.73Z",
    transform: "translate(0)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 467.39,
    cy: 42.4,
    r: 17.74
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 1289.6,
    cy: 84.3,
    r: 17.74
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M493.51,236c.72,1.52,2.76,5.87,1.46,10.37-.72,2.45-2,3.6-2.44,6.86s.72,3.89.17,5.86c-1.29,4.64-9.48,8.14-14.19,5.89-1.87-.89-1.82-2-4.72-3.61-2.71-1.49-4.31-1.34-6.32-2.11-4.63-1.77-6.86-6.65-7.48-8-3.31-7.25-1.13-19.72,9.13-24.39s21,2,24.39,9.13",
    transform: "translate(0)"
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M493.51,236c.72,1.52,2.76,5.87,1.46,10.37-.72,2.45-2,3.6-2.44,6.86s.72,3.89.17,5.86c-1.29,4.64-9.48,8.14-14.19,5.89-1.87-.89-1.82-2-4.72-3.61-2.71-1.49-4.31-1.34-6.32-2.11-4.63-1.77-6.86-6.65-7.48-8-3.31-7.25-1.13-19.72,9.13-24.39s21,2,24.39,9.13",
    transform: "translate(0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M492.83,261.92l-12,5.47a2.45,2.45,0,1,1-2-4.46l12-5.47a2.45,2.45,0,0,1,2,4.46",
    transform: "translate(0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M496,267.76l-12.19,5.55a2.35,2.35,0,1,1-2-4.28l12.2-5.55a2.35,2.35,0,1,1,1.94,4.28",
    transform: "translate(0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M498.48,274.11l-11.55,5.25a2.7,2.7,0,1,1-2.24-4.92l11.55-5.26a2.71,2.71,0,0,1,2.24,4.93",
    transform: "translate(0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M482.36,261.3s-3-9.05-5.53-11.05-2.38,3.58-.31,2.92a5.13,5.13,0,0,0,3.43-4.46c.3-2-3.32-3.16-1.81-.57s4.8.85,5.9.47-2-4.9-2.23-2.39,1.12,3,2.36,4.35,3.95,8.12,3.95,8.12",
    transform: "translate(0)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M466.86,232.15c1.56.7,1.86,3.45.65,6.12s-3.44,4.29-5,3.58-1.86-3.44-.66-6.12,3.45-4.28,5-3.58",
    transform: "translate(0)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M467.94,230.65c2.19,1,2.6,4.83.92,8.58s-4.83,6-7,5-2.61-4.82-.92-8.58,4.83-6,7-5",
    transform: "translate(0)"
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M498.68,280.58l-6.21,2.83a2.92,2.92,0,0,1-3.85-1.45l-.54-1.18a2.93,2.93,0,0,1,1.44-3.86l6.2-2.82a2.93,2.93,0,0,1,3.86,1.44l.54,1.19a2.92,2.92,0,0,1-1.44,3.85",
    transform: "translate(0)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 484.2,
    y1: 220.1,
    x2: 488.56,
    y2: 212.43
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 470.66,
    y1: 222.84,
    x2: 467.01,
    y2: 214.81
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 460.37,
    y1: 228.93,
    x2: 453.42,
    y2: 223.49
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 455.42,
    y1: 239.34,
    x2: 446.64,
    y2: 238.49
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 456.34,
    y1: 249.88,
    x2: 448.31,
    y2: 253.54
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 461.32,
    y1: 258.67,
    x2: 455.91,
    y2: 265.64
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 492.37,
    y1: 229.13,
    x2: 500.53,
    y2: 225.78
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 498.43,
    y1: 239.48,
    x2: 507.26,
    y2: 239.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagingdesignproduction6);
export default __webpack_public_path__ + "static/media/PACKAGING DESIGN & PRODUCTION 6.652d619c14588a7b9b29f4bc10c285d7.svg";
export { ForwardRef as ReactComponent };